import { Routes, Route } from 'react-router-dom';
import { GrowthDashboard } from './GrowthDashboard';
import { WikiArticles } from './wiki/WikiArticles';
import { MeetingsCalendar } from './meetings/MeetingsCalendar';
import { Campaigns } from './campaigns/Campaigns';
import { IdeaBox } from './ideas/IdeaBox';
import { DocumentLibrary } from './documents/DocumentLibrary';
import { GrowthReports } from './reports/GrowthReports';

export function GrowthHub() {
  return (
    <div className="growth-hub">
      <Routes>
        {/* Dashboard */}
        <Route index element={<GrowthDashboard />} />

        {/* Wiki */}
        <Route path="/wiki" element={<WikiArticles />} />

        {/* Meetings */}
        <Route path="/meetings" element={<MeetingsCalendar />} />

        {/* Marketing Campaigns */}
        <Route path="/marketing" element={<Campaigns />} />

        {/* Idea Box */}
        <Route path="/ideas" element={<IdeaBox />} />

        {/* Documents */}
        <Route path="/documents" element={<DocumentLibrary />} />

        {/* Reports */}
        <Route path="/reports" element={<GrowthReports />} />
      </Routes>
    </div>
  );
}
